import { render } from "./TypingIndicator.vue?vue&type=template&id=9e24894e&scoped=true"
const script = {}

import "./TypingIndicator.vue?vue&type=style&index=0&id=9e24894e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e24894e"]])

export default __exports__